import { AxiosResponse } from "axios";
import { GenericService } from "./Generic.service";

export class AllergieService extends GenericService<string> {
    readonly URI: string = "Alergia";
  
    constructor() {
      super();
      this.setUri(this.URI);
    }
  
    public async getAll() {
      return await super.getByResource("", { PageSize: 500 });
    }

    public async getAllergiesFilter({
      tipo,
      ...rest
    }: {
      tipo?: string;
    }) {
      return await super.getByResource<AxiosResponse<[]>>(``, {
        PageSize: 500,
        Tipo: tipo ? tipo : undefined,
        ...rest,
      });
    }

    public async getTypesAllergies(){
      return await super.getByResource("TiposAlergia");
    }
  
  }